module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/sanmar-835a0b464f97057a1c5343712635151f.svg";